const Colors = {
    Elmt: {
        Black: 0x303035,
        White: 0xFFFFFF,
        White50: 0xFFFFFF50,
        LightGrey: 0xF3F3F4,
        Grey: 0xE5E5E8,
        DarkerGrey: 0xBEB8B8,
        DarkGrey: 0x6C6E76,
        GreyBlue: 0x9799A3,
        LightBlue: 0xAAACF2,
        Blue: 0x5558E5,
        DarkBlue: 0x1D2D43,
        Orange: 0xE18628,
        LightOrange: 0xF0C294,
        Red: 0xA23535,
        Rose: 0xF7A0A0,
        GreenJardin: 0xE5F6A4,
        Green: 0x29762E
    },
    Text: {
        Black: "#303035",
        White: "#FFFFFF",
        White50: "#FFFFFF50",
        LightGrey: "#F3F3F4",
        Grey: "#E5E5E8",
        DarkerGrey: "#BEB8B8",
        DarkGrey: "#6C6E76",
        GreyBlue: "#9799A3",
        LightBlue: "#AAACF2",
        Blue: "#5558E5",
        DarkBlue: "#1D2D43",
        Orange: "#E18628",
        LightOrange: "#F0C294",
        Red: "#A23535",
        Rose: "#F7A0A0",
        GreenJardin: "#E5F6A4",
        Green: "#29762E"
    }
}

export {
    Colors
}